import React, { createContext, useContext } from 'react';
import { useQuery } from 'react-query';
import { getUserStatus } from '../services/userService';
import UserContext from './UserContext';

const GlobalStatusContext = createContext(null);

export const GlobalStatusProvider = ({ children }) => {
  const [userState] = useContext(UserContext);

  const { data, isLoading, error, refetch } = useQuery(
    'userStatus',
    getUserStatus,
    {
      enabled: !!userState.user, // Solo hacer fetch si el usuario está logueado
      refetchInterval: 60000, // Refrescar cada minuto por si hay nuevas notificaciones
      staleTime: 30000, // Considerar stale después de 30 segs
    }
  );

  return (
    <GlobalStatusContext.Provider value={{
      status: data?.data || null,
      isLoading,
      error,
      refetch
    }}>
      {children}
    </GlobalStatusContext.Provider>
  );
};

export const useGlobalStatus = () => useContext(GlobalStatusContext);
